<div class="w-full flex justify-content-center align-items-center">
    <div class="w-full p-4">
<!--        <div class="flex w-full justify-content-end">-->
<!--            <i class="pi pi-times border-2 p-1 text-red-500 border-red-500 cursor-pointer font-bold border-round-lg"-->
<!--               (click)="emitState(false)"></i>-->
<!--        </div>-->
        <div class="mt-3 flex">
            <i class="pi pi-exclamation-triangle text-7xl text-red-500 cursor-pointer"></i>
            <div class="flex flex-column ml-4">
                <span class="text-xl font-bold">
                    {{ 'sipo.sign-component.cancel-sign-confirmation-component.info-up' | translate }}
                </span>
                <span class="text-xl font-bold mt-3">
                    {{ 'sipo.sign-component.cancel-sign-confirmation-component.info-down' | translate }}
                </span>
            </div>
        </div>
        <div class="w-full align-items-center flex justify-content-between mt-5">
            <!--cancel process button begin-->
            <p-button
                [label]="'sipo.sign-component.cancel-sign-confirmation-component.cancel-button-info' | translate"
                outlined="true"
                class="border-round-lg"
                [style]="{'width': '25rem', 'height': '3.5rem', 'font-size': '13px'}"
                (click)="emitState(true, false)">
            </p-button>
            <!--cancel process button end-->
            <!--save as draft button begin-->
            <p-button
                [label]="'sipo.sign-component.cancel-sign-confirmation-component.draft-button-info' | translate"
                outlined="true"
                [disabled]="signerModel.signingProcessId.length === 0"
                class="border-round-lg"
                [style]="{'width': '20rem', 'height': '3.5rem', 'font-size': '13px'}"
                (click)="emitState(true, true)">
            </p-button>
            <!--save as draft button end-->
            <!--keep editing button begin-->
            <p-button
                [label]="'sipo.sign-component.cancel-sign-confirmation-component.continue-button-info' | translate"
                outlined="true"
                class="border-round-lg"
                [style]="{'width': '25rem', 'height': '3.5rem', 'font-size': '13px'}"
                (click)="emitState(false, false)">
            </p-button>
            <!--keep editing button end-->
        </div>
    </div>
</div>
